import api from './api';

const RenewalAlertsService = {
  async list(contractId = 'all', params = {}) {
    const response = await api.get(`/contracts/${contractId}/renewals-alerts`, { params });
    return response.data;
  },

  async create(contractId, payload) {
    const response = await api.post(`/contracts/${contractId}/renewals-alerts`, payload);
    return response.data;
  },

  async update(contractId, alertId, payload) {
    const response = await api.put(`/contracts/${contractId}/renewals-alerts/${alertId}`, payload);
    return response.data;
  },

  async remove(contractId, alertId) {
    const response = await api.delete(`/contracts/${contractId}/renewals-alerts/${alertId}`);
    return response.data;
  }
};

export default RenewalAlertsService;
